import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    position: 'relative',
    width: 'fit-content',
    '&, *': {
      padding: 0,
      margin: 0,
      boxSizing: 'border-box',
    },
    '&__tooltip': {
      display: 'none',
      position: 'absolute',
      width: 'fit-content',
      background: '#fff',
      boxShadow: '3px 4px 25px 0px #26323826',
      borderRadius: '1rem',
      padding: '0.75rem 1rem',
      whiteSpace: 'nowrap',
      fontSize: '0.75rem',
      weight: theme.value.typography.fontWeight.regular,
      lineHeight: '1.125rem',
      '&:before': {
        content: '""',
        width: 0,
        height: 0,
        position: 'absolute',
        borderStyle: 'solid',
      },
    },
    '&--visible &__tooltip': {
      display: 'block',
    },
    '&--top &__tooltip': {
      marginBottom: '1.5rem',
      left: '50%',
      bottom: '100%',
      transform: 'translateX(-50%)',
      background: '#fff',
      '&:before': {
        left: '50%',
        top: '99%',
        transform: 'translateX(-50%)',
        borderWidth: '15px 7.5px 0px 7.5px',
        borderColor: '#fff transparent transparent transparent',
      },
    },
    '&--right &__tooltip': {
      marginLeft: '1.5rem',
      top: '50%',
      left: '100%',
      transform: 'translateY(-50%)',
      '&:before': {
        top: '50%',
        right: '99%',
        transform: 'translateY(-50%)',
        borderWidth: '7.5px 15px 7.5px 0',
        borderColor: 'transparent #fff transparent transparent',
      },
    },
    '&--bottom &__tooltip': {
      marginTop: '1.5rem',
      left: '50%',
      top: '100%',
      transform: 'translateX(-50%)',
      '&:before': {
        left: '50%',
        bottom: '99%',
        transform: 'translateX(-50%)',
        borderWidth: '0 7.5px 15px 7.5px',
        borderColor: 'transparent transparent #fff transparent',
      },
    },
    '&--left &__tooltip': {
      marginRight: '1.5rem',
      top: '50%',
      right: '100%',
      transform: 'translateY(-50%)',
      '&:before': {
        top: '50%',
        left: '99%',
        transform: 'translateY(-50%)',
        borderWidth: '7.5px 0px 7.5px 15px',
        borderColor: 'transparent transparent transparent #fff',
      },
    },
    '&--multilined &__tooltip': {
      whiteSpace: 'normal',
      width: 'max-content',
    },
    '&--small &__tooltip': {
      maxWidth: '25ch',
    },
    '&--medium &__tooltip': {
      maxWidth: '30ch',
    },
    '&--large &__tooltip': {
      maxWidth: '35ch',
    },
  }));

  return baseClass;
};
